<div id="project-base">
  <div id="project-sidebar" *ngIf="showSidebarAndHeader">
    <kuv-sidebar [logo]="'/assets/system/logo_sidebar.png'" [routes]="routes"></kuv-sidebar>
  </div>
  <div id="project-header" *ngIf="showSidebarAndHeader">
    <ng-template #popTitle><label style="font-weight: 600;">Notificaciones</label></ng-template>
  <ng-template #popContent>
    <div *ngIf="stockCriticos.length == 0">
      No existen notificaciones.
    </div>
    <div *ngFor="let s of stockCriticos;">
      *El producto {{s.producto.nombre}} tiene {{s.cantidad}} unidades de un mínimo de {{s.producto.stock_minimo}}
  
    </div>

  </ng-template>

  <div *ngIf="sesion.sucursales.length > 0" class="mx-3">
    <select class="form-select" id="sucursal" [(ngModel)]="sesion.sucursalIndex" (change)="changeScope($event)">
      <ng-container *ngFor="let s of sesion.sucursales; let i = index">
        <option [value]="i">{{s.nombre}}</option>
      </ng-container>
    </select>
  </div>

    <div ngbDropdown class="d-inline-block mx-2">
      <button class="btn btn-kuv" id="dropdownBasic1" ngbDropdownToggle>
        <i class="fas fa-user"></i><span class="mx-2 d-none d-sm-inline"> Mi Cuenta</span>
      </button>

      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem (click)="verPerfil()">
          <div class="d-flex gap-2">
            <span class="mr-4">
              <i class="fas fa-user-alt"></i>
            </span>
            <div>Ver Perfil</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="changePass()">
          <div class="d-flex gap-2">
            <span class="mr-4">
              <i class="fas fa-key"></i>
            </span>
            <div>Cambiar Contraseña</div>
          </div>
        </button>
        <button ngbDropdownItem (click)="logout()">
          <div class="d-flex gap-2">
            <span class="mr-4">
              <i class="fas fa-sign-out-alt"></i>
            </span>
            <div>Cerrar Sesión</div>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div id="project-container" [ngClass]="{'no-sidebar': !showSidebarAndHeader}">
    <kuv-loading></kuv-loading>
    <kuv-alert></kuv-alert>
    <router-outlet></router-outlet>
  </div>
</div>